import { Expose } from 'class-transformer';
import { ElementOptions } from './element-options';

export class SurveySingleSelectElementOptions extends ElementOptions {
  @Expose()
  value!: number;

  @Expose({ name: 'allow_custom_value' })
  allowCustomValue!: boolean;

  @Expose()
  outlined!: boolean;

  @Expose()
  underlined!: boolean;

  @Expose()
  icon!: boolean;
}
